import { ApiRequest, ApiResponse } from 'services/providers/dapv.types';
import { dapvApi } from 'services/providers/dapv';
import {
    AllPartnersResponse,
    CreatePartnerCategoryPayload,
    CreatePartnerCategoryResponse,
    CreatePartnerPayload,
    CreatePartnerResponse,
    DeletePartnerCategoryPayload,
    DeletePartnerPayload,
    GetPartnerPayload,
    Partner,
    PartnerCategory,
    UpdatePartnerCategoryPayload,
    UpdatePartnerPayload
} from 'services/partner/partner.types';

const partnerApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        // Partners endpoints
        getAllPartners: build.mutation<ApiResponse<AllPartnersResponse[]>, ApiRequest<any>>({
            query: () => ({
                url: `/app/partners/categories`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<AllPartnersResponse[]>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getPartners: build.mutation<ApiResponse<Partner[]>, ApiRequest<any>>({
            query: () => ({
                url: `/app/partners`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<Partner[]>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getPartner: build.mutation<ApiResponse<Partner>, ApiRequest<GetPartnerPayload>>({
            query: (body: GetPartnerPayload) => ({
                url: `/app/partners/${body.id}`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<Partner>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        createPartner: build.mutation<ApiResponse<CreatePartnerResponse>, CreatePartnerPayload>({
            query: (body: CreatePartnerPayload) => ({
                url: '/app/partners',
                method: 'POST',
                body
            }),
            transformResponse: (response: ApiResponse<CreatePartnerResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updatePartner: build.mutation<ApiResponse<Partner>, ApiRequest<UpdatePartnerPayload>>({
            query: (body: UpdatePartnerPayload) => ({
                url: `/app/partners/${body.id}`,
                method: 'PUT',
                body
            }),
            transformResponse: (response: ApiResponse<Partner>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        deletePartner: build.mutation<ApiResponse<undefined>, DeletePartnerPayload>({
            query: (body: DeletePartnerPayload) => ({
                url: `/app/partners/${body.id}`,
                method: 'DELETE'
            }),
            transformResponse: (response: ApiResponse<undefined>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        // Partner categories endpoints
        createPartnerCategory: build.mutation<ApiResponse<CreatePartnerCategoryResponse>, CreatePartnerCategoryPayload>({
            query: (body: CreatePartnerCategoryPayload) => ({
                url: '/app/partners/categories',
                method: 'POST',
                body
            }),
            transformResponse: (response: ApiResponse<CreatePartnerCategoryResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updatePartnerCategory: build.mutation<ApiResponse<PartnerCategory>, ApiRequest<UpdatePartnerCategoryPayload>>({
            query: (body: UpdatePartnerCategoryPayload) => ({
                url: `/app/partners/categories/${body.id}`,
                method: 'PUT',
                body
            }),
            transformResponse: (response: ApiResponse<PartnerCategory>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        deletePartnerCategory: build.mutation<ApiResponse<undefined>, DeletePartnerCategoryPayload>({
            query: (body: DeletePartnerCategoryPayload) => ({
                url: `/app/partners/categories/${body.id}`,
                method: 'DELETE'
            }),
            transformResponse: (response: ApiResponse<undefined>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        })
    })
});

export const {
    useGetAllPartnersMutation,
    useGetPartnersMutation,
    useCreatePartnerCategoryMutation,
    useDeletePartnerCategoryMutation,
    useCreatePartnerMutation,
    useGetPartnerMutation,
    useUpdatePartnerMutation,
    useUpdatePartnerCategoryMutation,
    useDeletePartnerMutation
} = partnerApi;
